import React, { useState } from "react";
import PropTypes from "prop-types";
import { ComparisionViewButton, ChartWrapper, MainWrapper } from "../MetricDashboard.styles";
import { Chart } from "primereact/chart";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Loader } from "@vds/loaders";
import { CustomWrapper } from "../../../constants/common/StyledGlobalConstants";
import { useTranslation } from "react-i18next";
import CPNotification from "../../../pages/Login/CPNotification";

const CustomChart = ({ chartType, chartLabel, chartData, options, isLoading, jobTrendsNotification, onlineVsOfflineJobsTrendNotification }) => {
  const { t } = useTranslation("billingTranslation");
  const [isChartShow, setIsChartShow] = useState(false);

  const buttonHandle = () => {
    setIsChartShow(!isChartShow);
  };

  const chartWidth = () => {
    if (chartType === "pie") {
      return "350px !important";
    } else if (chartType === "barWithFullWidth") {
      return "1200px !important";
    }
    return "600px";
  };

  const chartDisplay = () => {
    if (chartData?.datasets[0]?.data?.length > 0) {
      return (
        <ChartWrapper>
          <div style={{ position: "relative", width: "1.5rem", height: "1.5rem", left: "50%" }} aria-label="loader overlay">
            <Loader active={isLoading} fullscreen={false} />
          </div>
          <Chart
            type={chartType === "barWithFullWidth" ? "bar" : chartType}
            data={chartData}
            options={options}
            width={chartWidth()}
            height="350px"
            plugins={[ChartDataLabels]}
          />
        </ChartWrapper>
      );
    } else {
      return (
        <CustomWrapper display="flex" justifyContent="center" alignItems="center">
          <h4 style={{ fontFamily: "neue-haas-grotesk-text", fontSize: "1rem", marginTop: "7rem" }} aria-label="No Records to display">
            {t("No Records to display")}
          </h4>
        </CustomWrapper>
      );
    }
  };

  const getJobTrendsNotification = () => {
    const successInfo = jobTrendsNotification.filter((item) => item.type === "success");
    const errorInfo = jobTrendsNotification.filter((item) => item.type === "error");
    return (
      <>
        {successInfo.length > 0 && (
          <ul
            style={{
              background: "#D6F2E0",
              margin: "1rem 1rem 0rem 2rem",
              padding: "1rem 0rem 1rem 2rem",
              fontSize: "1rem",
            }}
          >
            {successInfo?.map((msg, index) => {
              const keyIndexValue = `notification-${index}`;
              return (
                <li key={keyIndexValue} style={{ height: "1.7rem" }}>
                  {msg.content}
                </li>
              );
            })}
          </ul>
        )}
        {errorInfo.length > 0 && (
          <ul
            style={{
              background: "#FFECE0",
              margin: "1rem 1rem 0rem 2rem",
              padding: "1rem 0rem 1rem 2rem",
              fontSize: "1rem",
            }}
          >
            {errorInfo?.map((msg, index) => {
              const keyIndexValue = `notification-${index}`;
              return (
                <li key={keyIndexValue} style={{ height: "1.7rem" }}>
                  {msg.content}
                </li>
              );
            })}
          </ul>
        )}
      </>
    );
  };

  return (
    <MainWrapper>
      <CustomWrapper display="flex" justifyContent="center" alignItems="center">
        <ComparisionViewButton isChartShow={isChartShow} onClick={buttonHandle}>
          {chartLabel}
        </ComparisionViewButton>
      </CustomWrapper>
      {isChartShow && (
        <>
          {jobTrendsNotification?.length > 0
            ? getJobTrendsNotification()
            : onlineVsOfflineJobsTrendNotification && (
                <CustomWrapper display="flex" marginTop="1rem" marginRight="1rem" marginLeft="2rem">
                  <CPNotification isOpen={true} notificationType={onlineVsOfflineJobsTrendNotification.type}>
                    {onlineVsOfflineJobsTrendNotification.content}
                  </CPNotification>
                </CustomWrapper>
              )}
        </>
      )}
      <CustomWrapper display="flex" justifyContent="center" alignItems="center" flexDirection="column">
        {isChartShow ? <>{chartDisplay()}</> : null}
      </CustomWrapper>
    </MainWrapper>
  );
};

CustomChart.propTypes = {
  chartType: PropTypes.string.isRequired,
  chartLabel: PropTypes.string,
  chartData: PropTypes.object,
  options: PropTypes.object,
  isLoading: PropTypes.bool,
  jobTrendsNotification: PropTypes.array,
  onlineVsOfflineJobsTrendNotification: PropTypes.object,
};

export default CustomChart;